import { useParams } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import Spinner from "../components/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import { getOrderPublic, checkPaymentStatus } from "../features/orders/orderSlice";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";

function Processing() {
    const { orderId } = useParams();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const refParam = searchParams.get('ref');
    const jsonParam = searchParams.get('json');

    const parsedJsonRef = useMemo(() => {
        if (!jsonParam) return null;
        try {
            const parsed = JSON.parse(jsonParam);
            return parsed?.merchant_data || parsed?.reference || null;
        } catch (e) {
            console.error('Failed to parse json query param', e);
            return null;
        }
    }, [jsonParam]);

    const lookupId = orderId || refParam || parsedJsonRef;

    const order = useSelector(state => state.order.order);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [refreshCount, setRefreshCount] = useState(0);
    const missingOrderId = !lookupId;
    const timeoutTicks = 60; // seconds

    useEffect(() => {
        if (missingOrderId) return;
        const fetchOrderStatus = async () => {
            try {
                const statusResult = await dispatch(checkPaymentStatus(lookupId)).unwrap();
                if (statusResult?.orderStatus === 'new') {
                    localStorage.removeItem('cart_v2');
                    window.location.href = `/order-confirmation/${statusResult.orderId || lookupId}`;
                    return;
                }

                await dispatch(getOrderPublic(lookupId));
                setRefreshCount(prevCount => prevCount + 1);
            } catch (error) {
                console.error('Error fetching order status:', error);
            }
        };

        const intervalId = setInterval(fetchOrderStatus, 1000);
        return () => clearInterval(intervalId);
    }, [dispatch, lookupId, missingOrderId]);

    useEffect(() => {
        if (order && order.status === 'new') {
            window.location.href = `/order-confirmation/${order._id}`;
            localStorage.removeItem('cart_v2');
        }
    }, [order]);

    useEffect(() => {
        const exceeded = refreshCount >= timeoutTicks;
        if (exceeded && (!order || order.status !== 'new')) {
            toast.error('Kaut kas nogāja greizi. Lūdzu mēģiniet vēlreiz.');
            navigate('/');
        }
    }, [navigate, order, refreshCount, timeoutTicks]);

    return (
        <div className="processing">
            {missingOrderId ? (
                <div style={{ textAlign: 'center', padding: '40px 16px' }}>
                    <h2>Order ID is missing</h2>
                    <p>We couldn&apos;t detect a valid order. Please return to the shop and try again.</p>
                    <button className="btn" onClick={() => navigate('/')}>Back to shop</button>
                </div>
            ) : (
                <Spinner />
            )}
        </div>
    );
}

export default Processing;
